<template>
    <div v-if="!$core.getConfig().showMaintenance()" class="community-shorts">
        <div class="row" @click="getOnline()">
            <div class="shorts label">online</div>
            <div class="shorts value">{{ online }}</div>
        </div>
        <div class="row" @click="getChat()">
            <div class="shorts label">im Chat</div>
            <div class="shorts value">{{ chat }}</div>
        </div>
        <div class="row" @click="getAllMembers()">
            <div class="shorts label">Mitglieder</div>
            <div class="shorts value">{{ members }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommunityShorts',
    data()
    {
        return {
            guests:  '...',
            online:  '...',
            chat:    '...',
            members: '...'
        }
    },
    
    created()
    {
        this.$core.getCoreTimer()
            .addInterval( 'community-shorts', 10000, () =>
            {
                this.refresh()
            }, true );
    },
    
    beforeUnmount()
    {
        this.$core.getCoreTimer()
            .removeInterval( 'community-shorts' )
    },
    
    methods: {
        
        refresh()
        {
            this.$core.getClient()
                .request( {
                    method:       'basic.getCommunityShorts',
                    looseSession: true
                } )
                .then( response =>
                {
                    this.members = response.result.memberCounter
                    this.chat = response.result.chatCounter
                    this.online = response.result.onlineCounter
                } )
                .catch( () =>{
                })
            
        },
        
        getOnline()
        {
            this.$core
                .ui()
                .showInfoScreen( 'online' )
        },
        
        getChat()
        {
            this.$core
                .ui()
                .showInfoScreen( 'chat' )
        },
        
        getAllMembers()
        {
            this.$core
                .ui()
                .showInfoScreen( 'members' )
        }
        
        
    }
}
</script>